
// Utility functions for device detection and capabilities

/**
 * Check if the current device is a mobile device
 * This helps determine if haptic feedback is potentially available
 */
export const isMobile = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

/**
 * Check if the device is iOS
 */
export const isIOS = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  
  return /iPhone|iPad|iPod/i.test(navigator.userAgent) && 
          !(/Android/i.test(navigator.userAgent));
};

/**
 * Check if the device is Android
 */
export const isAndroid = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  
  return /Android/i.test(navigator.userAgent);
};

/**
 * Check if the browser is Safari
 * Safari has specific PWA-related properties
 */
export const isSafari = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

/**
 * Check if the app is running in standalone mode (installed as PWA)
 * We need to type cast for Safari's standalone property
 */
export const isStandalone = (): boolean => {
  try {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
    
    return window.matchMedia('(display-mode: standalone)').matches || 
           (navigator as any).standalone === true;
  } catch (error) {
    console.warn('Error checking standalone status:', error);
    return false;
  }
};

/**
 * Check if running on a preview/dev host where SW should not be registered
 */
export const isPreviewHost = (): boolean => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host.includes('lovable.app') || 
         host.includes('lovableproject.com') || 
         host === 'localhost' || 
         host === '127.0.0.1';
};
